import { FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { GoogleMap, OverlayView, useJsApiLoader } from '@react-google-maps/api'

import publicConfig from '@/config/public'
import { Grid, GridProps, SvgIcon } from '@/tbui'

interface MapProps extends GridProps {
  longitude: number
  latitude: number
  small?: boolean
  height?: string
  width?: string
}

const StyledMapWrapper = styled(Grid)<MapProps>`
  display: block;
  border: 1px solid ${(props) => props.theme.palette.GRAY_1};
  ${(props) => props.height && { height: props.height }};
  ${(props) => props.width && { width: props.width }};
  background-color: ${(props) => props.theme.palette.SECONDARY};
  ${(props) =>
    props.theme.mixin.fluidRange(
      {
        prop: 'height',
        fromSize: '100px',
        toSize: props.small ? '100px' : '150px',
      },
      {
        prop: 'width',
        fromSize: '115px',
        toSize: props.small ? '115px' : '175px',
      }
    )};
`

const StyledSvgIcon = styled(SvgIcon)`
  // Center the icon's bottom tip on the lat/lng point.
  transform: translate(-50%, -100%);
  pointer-events: none;
`

const mapContainerStyle = { width: '100%', height: '100%' } as const
const mapOptions: google.maps.MapOptions = { fullscreenControl: false }

const Map: FunctionComponent<MapProps> = ({ ...wrapperProps }) => {
  const { isLoaded } = useJsApiLoader({
    id: 'tb-google-maps-script',
    googleMapsApiKey: publicConfig.googleMapsAPIKey,
  })

  const center = { lat: wrapperProps.latitude, lng: wrapperProps.longitude }

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledMapWrapper {...wrapperProps} data-test="google-maps">
      {isLoaded && (
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={center}
          zoom={11}
          options={mapOptions}
        >
          <OverlayView position={center} mapPaneName={OverlayView.OVERLAY_LAYER}>
            <StyledSvgIcon name="map_marker" fontSize="28px" />
          </OverlayView>
        </GoogleMap>
      )}
    </StyledMapWrapper>
  )
}

export default Map
